import { backgroundLogin, selectAccountLogin } from "./oauth.js";

export async function aquireSession(): Promise<string> {
    displayLanding();
    let token_id;
    try {
        token_id = await backgroundLogin("kase");
        if (token_id) {
            return token_id;
        }
    } catch (e) {
        console.error(e);
    }
    return showLogin();
}

function displayLanding(): void {
    const div = document.createElement("div");
    div.textContent = "Loading...";
    document.body.appendChild(div);
}

function showLogin(): Promise<string> {
    const div = document.createElement("div");
    div.textContent = "Please login.";
    const button = document.createElement("button");
    button.textContent = "Login";
    div.appendChild(button);
    document.body.lastChild?.remove();
    document.body.appendChild(div);
    return new Promise((resolve) => {
        button.addEventListener("click", () => {
            button.disabled = true;
            selectAccountLogin("kase")
                .then(resolve)
                .catch(() => {
                    button.disabled = false;
                });
        });
    });
}
